
const PasswordModel = () => {

    return(
        <div className="modal fade password-model" id="passwordModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                        <div className="title-content">
                            <h3 className="model-title">استرداد الحساب</h3>
                            <p className="model-subtitle">ادخل بريدك الإلكترونى وسنقوم بإرسال رابط التفعيل لاسترداد حسابكم</p>

                        </div>
                        <form >
                            <div className="form-group cassandra-form-group">
                                <label>البريد الإلكترونى</label>
                                <input  className="form-control cassandra-form-control" type="email" placeholder="يرجى إدخال البريد الإلكتروني المسجل لدينا"/>
                            </div>
                          
                            <div className="text-center">
                                 <input className="submit-btn" type="submit" value="إرسال رابط التفعيل"/>  
                            </div>
                        </form>
                    </div>
                </div>
            </div>
         </div>
    );

};
export default PasswordModel;
